'use client';
import { isString, invariantSync } from '@s7/utils';
import { URLConstraintError } from '../../domain/errors/URLConstraintError.js';

var getComposedInput = function(input, prefixUrl) {
    if (prefixUrl && isString(input)) {
        var withLeadingSlash = input.startsWith("/");
        invariantSync(withLeadingSlash, function() {
            return new URLConstraintError();
        });
        return (!String(prefixUrl).endsWith("/") ? "" + prefixUrl + "/" : prefixUrl) + input;
    }
    return input;
};

export { getComposedInput };
